import { render, staticRenderFns } from "./wallet-dialog.vue?vue&type=template&id=4a3ba392&scoped=true&"
import script from "./wallet-dialog.vue?vue&type=script&lang=js&"
export * from "./wallet-dialog.vue?vue&type=script&lang=js&"
import style0 from "./wallet-dialog.vue?vue&type=style&index=0&id=4a3ba392&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3ba392",
  null
  
)

export default component.exports